/**
 * @module constants
 * @description These are constants
 */

/**
 * @name APP_CURRENT_VERSION
 * @const {string}
 *
 * @description web app version should match with package.json version.
 * It should be changed on each app update.
 * @example APP_CURRENT_VERSION = 0.1.1
 */
export const APP_CURRENT_VERSION = '0.2.17';
